import _ from 'lodash';
import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormService {
    constructor() {}

    isFormValid(form: UntypedFormGroup | UntypedFormArray, exclude: string[] = []): boolean {
        const list = _.map(form.controls, (control: UntypedFormControl | UntypedFormGroup | UntypedFormArray, key) => {
            const includes = _.includes(exclude, key);
            if(includes) {
                return true;
            };
            if(control instanceof UntypedFormGroup) {
                return this.isFormValid(control, exclude);
            }
            if(control instanceof UntypedFormArray) {
                return this.isFormValid(control, exclude);
            }
            return !control.invalid;
        });
        return _.every(list, (value) => {
            return _.isEqual(value, true);
        });
    }

    reset(form) {
        if(form === null) {
            return;
        }
        
        _.forEach(form.controls, control => {
            if(control instanceof UntypedFormGroup) {
                this.reset(control);
            } else if(control instanceof UntypedFormArray) {
                while (control.length !== 0) {
                    control.removeAt(0)
                }
            } else {
                control.reset();
            }
        });
    }
}
